import { useAPIClient } from "render/context/APIContext";
import { useCallback } from "react";
import { useSession } from "render/context/MSALContext";

export function useRevokeStudyConsentMutation() {
  const { patientId } = useSession();
  const client = useAPIClient().consent;

  return useCallback(
    (consentId: string) => {
      return client.revokeConsent({ patientId, consentId }).result;
    },
    [client, patientId]
  );
}
